import { Button } from 'antd';
import { OrderedListOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

export const numberedListCommand = ({ editor, range }) =>
  range
    ? editor.chain().focus().deleteRange(range).toggleOrderedList().run()
    : editor.chain().focus().toggleOrderedList().run();

const NumberedList = ({ editor, showLabel = false, indicateActive = true, isExtension = false }) => {
  return (
    <Button
      className={`editor-toolbar-btn-container ${indicateActive && editor.isActive('orderedList') ? '!bg-slate-100 text-black' : '!bg-transparent'}`}
      icon={<OrderedListOutlined className="text-gray-800 text-xs" />}
      onClick={isExtension ? () => {} : () => numberedListCommand({ editor })}
      size="small"
      type="text"
    >
      {showLabel && (
        <div className="editor-toolbar-btn-label">
          <FormattedMessage id="NUMBERED_LIST" defaultMessage="Numbered list" />
        </div>
      )}
    </Button>
  );
};

export default NumberedList;
